import AlbumsList from './AlbumsList';

export default AlbumsList;
